var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("icon", { attrs: { size: _vm.size, type: _vm.sensorType } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }